/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Returnairco23Inputs */



/**
* | output |
* | --- |
* | "Return air CO2" |
*
* @param {Ahu_History_Key_Returnairco23Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_returnairco23 = /** @type {((inputs?: Ahu_History_Key_Returnairco23Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Returnairco23Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Return air CO2")
	return /** @type {LocalizedString} */ ("CO2 air reprise")
});
export { ahu_history_key_returnairco23 as "ahu_history_key_returnAirCO2" }